import type { DocumentPageListItem } from '@avisoma//shared';

export function DocumentPageMarkdownColumn({
  page,
  showAdvancedView,
}: {
  page: DocumentPageListItem;
  showAdvancedView: boolean;
}) {
  return (
    <div className="bg-gray-50 dark:bg-zinc-800 border p-3 dark:border-zinc-700 aspect-3/4 overflow-y-auto shadow-[0_0_10px_rgba(0,0,0,0.1)]">
      {!showAdvancedView && page.processing?.metadata?.status === 'done' && (
        <>
          <div className="flex items-top justify-between gap-2">
            <div>
              <h2 className="text-sm font-medium text-gray-700 dark:text-zinc-100">
                {page.processing?.metadata?.result?.title}
              </h2>
              <h3 className="text-xs font-extralight text-gray-500 dark:text-zinc-400 mb-3">
                {page.processing?.metadata?.result?.type}
              </h3>
            </div>
            <p className="text-xs font-light text-gray-500 dark:text-zinc-400">
              {page.processing?.metadata?.result?.date}
            </p>
          </div>
          <p className="text-xs font-light text-gray-900 dark:text-zinc-100 flex gap-2">
            {page.processing?.metadata?.result?.esn && (
              <span>
                <span className="font-medium">ESN:</span>
                {page.processing.metadata.result.esn}
              </span>
            )}
            {page.processing?.metadata?.result?.tsn && (
              <span>
                <span className="font-medium">TSN:</span>
                {page.processing.metadata.result.tsn}
              </span>
            )}
            {page.processing?.metadata?.result?.csn && (
              <span>
                <span className="font-medium">CSN:</span>
                {page.processing.metadata.result.csn}
              </span>
            )}
          </p>
          <hr className="my-2 border-gray-400 dark:border-zinc-700" />
        </>
      )}

      <div className="text-[10px] text-gray-900 dark:text-zinc-100 font-mono overflow-auto">
        <h6 className="font-bold text-gray-900 dark:text-zinc-100">
          {page.processing?.pdfParser?.result?.classificationData?.title}
        </h6>
        {page.processing?.pdfParser?.result?.classificationData?.description}
      </div>
    </div>
  );
}
